import { Helmet } from 'react-helmet'

import { LegalSideNav } from './components/LegalSideNav'
import { PRIVACY_SECTIONS } from './content/privacySections'

export function Privacy() {
  return (
    <section className="mx-auto max-w-(--maxw) px-5.5 pt-24 pb-16 max-md:pt-16 max-md:pb-12">
      <Helmet>
        <title>Privacy Policy</title>
      </Helmet>
      <meta
        name="description"
        content="How Cai Labs, Inc. collects, uses, discloses, and otherwise processes Personal Information in connection with our Services."
      />
      <div className="grid grid-cols-[200px_minmax(0,760px)] items-start justify-center gap-16 max-[900px]:grid-cols-[minmax(0,760px)]">
        <LegalSideNav sections={PRIVACY_SECTIONS} />

        <div className="min-w-0">
          <div className="mb-12 flex flex-col gap-4">
            <span className="eyebrow self-start">Legal</span>
            <h1 className="h2 mt-2">Privacy Policy</h1>
            <p className="text-ink-400 m-0 font-mono text-xs leading-normal">Last Updated: June 1, 2026</p>
            <p className="text-md text-ink-700 leading-[1.6]">
              At Cai Labs, we understand that your privacy is an important part of the trust you place in us.
              This Policy explains how we collect, use, disclose, and otherwise process Personal Information
              about you collected in connection with our Services, including our websites and mobile
              applications that post or link to this Policy.
            </p>
            <p className="text-md text-ink-700 leading-[1.6]">
              When we use the terms &ldquo;Cai Labs&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;, or
              &ldquo;our&rdquo; in this Policy, we are referring to Cai Labs, Inc. and its subsidiaries and
              affiliated companies.
            </p>
            <p className="text-md text-ink-700 leading-[1.6]">
              The term &ldquo;Services&rdquo; in this Policy is defined to include our website(s), all mobile
              or web-based software platforms, including the FuelApp application and the related services we
              offer to our customers, unless we provide a different privacy policy to individuals at the time
              we collect their Personal Information. Please note this Policy does not apply to our processing
              of employee or contractor Personal Information.
            </p>
          </div>

          <div className="flex flex-col gap-16 max-md:gap-12">
            {PRIVACY_SECTIONS.map((section) => (
              <div key={section.number} id={`section-${section.number}`} className="scroll-mt-[86px]">
                <h2 className="text-ink m-0 text-2xl leading-[1.2] font-bold tracking-[-0.01em]">
                  {section.number}. {section.title}
                </h2>
                <div className="text-md text-ink-700 [&_a]:text-brand-800 [&_a:hover]:text-ink mt-6 flex flex-col gap-6 leading-[1.6] [&_a]:underline [&_a]:underline-offset-2">
                  {section.body}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
